import { useState } from 'react';
import c from '../../styles/auth.module.css';

const EMPTY = { firstName: '', lastName: '', username: '', email: '', password: '', role: 'staff' };

export function AddStaffForm({ onCreate, light, onClose }) {
  const [form, setForm]         = useState(EMPTY);
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState('');
  const [isLoading, setLoading] = useState(false);

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const { firstName, lastName, email, password } = form;
    if (!firstName || !lastName || !email || !password) {
      setError('Missing required fields');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    const result = await onCreate(form);
    setLoading(false);
    if (result.status === 'success') {
      setForm(EMPTY);
      setSuccess(`Added ${firstName} ${lastName}`);
      if (onClose) onClose();
    } else {
      setError(result.message || 'Failed to add staff');
    }
  };

  return (
    <form className={`${c.card} ${light ? c.lightCard : ''}`} onSubmit={onSubmit} style={{ maxWidth: 'none', margin: 0 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
        <div className={c.title} style={{ margin: 0 }}>Add Staff</div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            style={{ background: 'transparent', border: 'none', color: 'inherit', fontSize: 20, lineHeight: 1, cursor: 'pointer' }}
          >
            ✕
          </button>
        )}
      </div>

      {error && <div className={c.error}>{error}</div>}
      {success && <div className={c.error} style={{ background: 'rgba(74,138,110,0.13)', borderColor: 'rgba(109,184,138,0.4)', color: '#6db88a' }}>{success}</div>}

      <div className={c.row}>
        <div className={c.field}>
          <label className={c.label} htmlFor="firstName">First Name</label>
          <input id="firstName" className={c.input} type="text" placeholder="First name" value={form.firstName} onChange={update('firstName')} />
        </div>
        <div className={c.field}>
          <label className={c.label} htmlFor="lastName">Last Name</label>
          <input id="lastName" className={c.input} type="text" placeholder="Last name" value={form.lastName} onChange={update('lastName')} />
        </div>
      </div>

      <div className={c.field}>
        <label className={c.label} htmlFor="email">Email</label>
        <input id="email" className={c.input} type="email" placeholder="you@example.com" value={form.email} onChange={update('email')} />
      </div>

      <div className={c.field}>
        <label className={c.label} htmlFor="username">Username <span style={{ opacity: 0.5 }}>(optional)</span></label>
        <input id="username" className={c.input} type="text" autoComplete="off" placeholder="e.g. frontdesk" value={form.username} onChange={update('username')} />
      </div>

      <div className={c.row}>
        <div className={c.field}>
          <label className={c.label} htmlFor="password">Password</label>
          <input id="password" className={c.input} type="password" autoComplete="new-password" placeholder="••••••••" value={form.password} onChange={update('password')} />
        </div>
        <div className={c.field}>
          <label className={c.label} htmlFor="role">Role</label>
          <select id="role" className={c.input} value={form.role} onChange={update('role')}>
            <option value="staff">Staff</option>
            <option value="admin">Admin</option>
            <option value="share_device">Shared Device</option>
          </select>
        </div>
      </div>

      <button className={c.button} type="submit" disabled={isLoading}>
        {isLoading ? 'Adding…' : 'Add Staff'}
      </button>
    </form>
  );
}
